<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar"/>

    <breadcrumb class="breadcrumb-container"/>

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <!--          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
          <!--          <i class="el-icon-caret-bottom" />-->
          <span>你好，{{ user.enterprise_name == '' ? user.name : user.enterprise_name }}</span>
          <i class="el-icon-caret-bottom" style="top: 20px"/>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/my">
            <el-dropdown-item>
              个人中心
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;color: crimson">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div
      class="right-menu"
      style="
    width: 100px;
    height: 60px;
    line-height: 60px;
"
    >
      <el-button type="text" size="medium" @click="drawer = true">
        <el-badge is-dot class="item" :hidden="!isNew">
          消息中心
        </el-badge>
      </el-button>
    </div>

    <div
      class="right-menu"
      style="
    width: 100px;
    height: 60px;
    line-height: 60px;
"
    >
      <el-link type="primary" size="medium" :href="homepath">回到首页</el-link>
    </div>

    <el-drawer
      title="消息中心"
      :visible.sync="drawer"
      style="overflow:auto"
      @close="visited"
    >
      <template v-if="paginate.data.length > 0">
        <div v-infinite-scroll="nextMessage">
          <el-card v-for="item in paginate.data" :key="item.id" style="margin: 20px 10px">
            <div slot="header" class="clearfix">
              <span class="red-point" v-if="item.status < 1"></span><span>{{ item.title }}</span>
            </div>
            <div v-html="item.content"></div>
            <span class="message-time">{{ item.created_at }}</span>
          </el-card>
        </div>
      </template>
      <el-empty v-else description="没有消息"/>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { get, visit } from '@/api/mail'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'user'
    ])
  },
  data() {
    return {
      drawer: false,
      paginate: {
        data: [],
        current_page: 0,
        total: 0,
        per_page: 15
      },
      hasIds: [],
      bottom: false,
      isNew: false,
      homepath: process.env.VUE_APP_BASE_URL,
    }
  },
  created() {
    this.nextMessage()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    nextMessage() {
      if (this.paginate.current_page * this.paginate.per_page > this.paginate.total) {
        this.bottom = true
        return
      }
      get(++this.paginate.current_page).then(response => {
        let count = 0
        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].status === 1) {
            this.isNew = true
            count++
          }
          if (this.hasIds.indexOf(response.data[i].id) === -1) {
            this.hasIds.push(response.data[i].id)
            this.paginate.data.push(response.data[i])
          }
        }
        if (this.isNew && count > 0) {
          this.$notify({
            title: '新的消息',
            message: '你收到' + count + '条新的消息',
            type: 'success'
          })
        }
        const { per_page, current_page, total } = response
        this.paginate.per_page = per_page
        this.paginate.current_page = current_page
        this.paginate.total = total
      })
    },
    visited() {
      this.isNew = false
      visit({}).then(() => {
        for (let i = 0; i < this.paginate.data.length; i++) {
          this.paginate.data[i].status = 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      :hover {
        color: #409EFF;
      }

      margin-right: 30px;
      cursor: pointer;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }

  .message-time {
    color: #666;
    font-size: 12px;
  }

  .red-point {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: red;
    border-radius: 2.5px;
    margin: 3px 10px;
  }
}
</style>
